export enum SiteTableColumns {
  AbbreviationLocal = "abbreviationLocal",
  AbbreviationLatin = "abbreviationLatin",
  NameLocal = "nameLocal",
  NameLatin = "nameLatin",
  ExternalId = "externalId",
  CountryCode = "countryCode",
  SiteId = "siteId",
}
